import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getCompanySettings } from '../services/api';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [company, setCompany] = useState({
    company_name: 'PT CITRA HERITAGE INDONESIA',
    company_whatsapp: '628123456789',
    logo: '/logo.png',
  });
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    getCompanySettings().then(data => {
      if (data && data.company_name) {
        setCompany(prev => ({ ...prev, ...data, logo: data.logo || prev.logo }));
      }
    }).catch(() => {});
  }, []);

  const toggleMob = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <>
      <header id="hdr" className={scrolled ? 'scrolled' : ''}>
        <div className="hdr-inner">
          <Link to="/" className="hdr-logo">
            <img src={company.logo || '/logo.png'} alt={company.company_name || 'PT CITRA HERITAGE INDONESIA'} className="logo-img" onError={(e) => { e.target.src = '/logo.png'; }} />
          </Link>
          <nav className="hdr-nav">
            <Link to="/" className={isActive('/')}>Home</Link>
            <Link to="/about" className={isActive('/about')}>About</Link>
            <Link to="/components" className={isActive('/components')}>Components</Link>
            <Link to="/parts" className={isActive('/parts')}>Parts</Link>
            <Link to="/services" className={isActive('/services')}>Services</Link>
            <Link to="/blog" className={isActive('/blog')}>Blog</Link>
            <Link to="/contact" className={isActive('/contact')}>Contact</Link>
          </nav>
          <div className="hdr-right">
            <a href={`https://wa.me/${(company.company_whatsapp || '6281234567890').replace(/[^0-9]/g,'')}?text=${encodeURIComponent('Hello AFS, I would like to request a quote for your products/services. Please provide me with more information. Thank you.')}`} className="btn btn-y" target="_blank" rel="noopener noreferrer">Get a Quote ↗</a>
            <button className="hamburger" onClick={toggleMob}>
              <span></span><span></span><span></span>
            </button>
          </div>
        </div>
      </header>

      <div className={`mob-nav ${isMobileMenuOpen ? 'open' : ''}`}>
        <button className="mob-close" onClick={toggleMob}>✕</button>
        <Link to="/" onClick={toggleMob}>Home</Link>
        <Link to="/about" onClick={toggleMob}>About</Link>
        <Link to="/components" onClick={toggleMob}>Components</Link>
        <Link to="/parts" onClick={toggleMob}>Parts</Link>
        <Link to="/services" onClick={toggleMob}>Services</Link>
        <Link to="/blog" onClick={toggleMob}>Blog</Link>
        <Link to="/contact" onClick={toggleMob}>Contact</Link>
        <a href={`https://wa.me/${(company.company_whatsapp || '6281234567890').replace(/[^0-9]/g,'')}?text=${encodeURIComponent('Hello AFS, I would like to request a quote for your products/services. Please provide me with more information. Thank you.')}`} className="btn btn-y" style={{marginTop:'20px',justifyContent:'center'}} target="_blank" rel="noopener noreferrer" onClick={toggleMob}>Get a Quote ↗</a>
      </div>
    </>
  );
};

export default Header;
